import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DocViewerContextPanelAnimations } from '../doc-viewer-context-panel-template/doc-viewer-context-panel.animations';
import { DocViewerStore } from "@store/legacy/doc-viewer.store";
import { Store } from "@ngrx/store";
import { ContextPanelViews } from "@store/doc-viewer/doc-viewer.state";

import { contextPanelActions } from "@store/doc-viewer/context-panel/context-panel.actions";
import { currentContextPanel } from "@store/doc-viewer/context-panel/context-panel.selectors";
import { map } from 'rxjs';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'lex-doc-viewer-context-panel',
    templateUrl: './doc-viewer-context-panel.component.html',
    styleUrls: ['./doc-viewer-context-panel.component.scss'],
    animations: DocViewerContextPanelAnimations,
    standalone: false
})
export class DocViewerContextPanelComponent extends BaseComponent {
	@Input() panelWidth: number;
	@Output() panelStateChangeOnToggle: EventEmitter<string> = new EventEmitter();
	public panelState: 'expanded' | 'collapsed' = 'expanded';
	public panelExpandWidth: number = 310;
	public panelCollapseWidth: number = 65;
	public maxAnimationWidth: string;
	public isAnimationDisabled: boolean = true;
	public currentPanel$ = this.store.select(currentContextPanel());
	public isReviewMode: boolean = false;
	public shouldShowReviewContextPanel$ = this.docViewerStore.simpleState$.pipe(
		map((state) => {
			this.isReviewMode = state.mode === 'review';
			if(this.isReviewMode) this.store.dispatch(contextPanelActions.setContextPanel({selectedContext: 'review'}));
			return this.isReviewMode;
		})
	);

	constructor(
		private docViewerStore: DocViewerStore,
		private store: Store
	) {
		super();
		const data = localStorage.getItem("docViewerContextPanel");
		const json = JSON.parse(data);
		if (json?.state) {
			this.panelState = json.state === 'expanded' ? 'expanded' : 'collapsed';
		}
		if (json?.width) {
			this.panelWidth = json.width;
		}

		this.maxAnimationWidth = this.panelWidth + 'px';
	}

	public toggle(): void {
		this.isAnimationDisabled = false;
		this.panelState = this.panelState === 'expanded' ? 'collapsed' : 'expanded';
		this.panelWidth = this.panelState === 'expanded' ? this.panelExpandWidth : this.panelCollapseWidth;

		this.panelStateChangeOnToggle.emit(this.panelState);
	}

	public animationDone(): void {
		this.setSessionState();
		this.isAnimationDisabled = true;
	}

	@HostListener('window:mouseup')
	windowMouseUp() {
		this.setSessionState();
		if (this.panelState === 'expanded') {
			this.maxAnimationWidth = this.panelWidth + 'px';
		} else {
			this.maxAnimationWidth = this.panelExpandWidth + 'px';
		}
	}

	public setSessionState(): void {
		this.docViewerStore.updateState((currentState) => {
			currentState.leftPanelState = this.panelState;
			currentState.leftPanelWidth = this.panelWidth;
			return currentState;
		});

		const panel = {
			state: this.panelState,
			width: this.panelWidth
		}
		localStorage.setItem('docViewerContextPanel', JSON.stringify(panel));
	}

	public changeListView(desiredState: ContextPanelViews) {
		this.store.dispatch(contextPanelActions.setContextPanel({selectedContext: desiredState}));
	}
}
